import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right2--sprite",
  "use": "arrow-right2--sprite-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"arrow-right2--sprite\"><path d=\"m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol